import { xBaseTheme } from "@guestsupply/XDL/types";

export default {
    popover: 1260,
    datePicker: 1270,
    dynamicDropdown: 1280,
    stickyFooter: 1284,
    loadingOverlay: 1280,
    menu: 1290,
    drawer: 1290,
    modal: 1300,
    tabGroup: 400,
    // XNG-Change
    toaster: 1501,
    header: 1284,
    tippy: 1500,
    compactHeader: 1284,
    styledOverlay: 1281,
} as xBaseTheme["zIndex"];
